<template>
  <DoneCard v-if="order" :order="order" :index="1" :activeOrder="1" />
</template>
<script setup>
import DoneCard from "@/components/done/DoneCard.vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { reAuthorize } from "@/services/auth/re-auth";

const order = ref(null);
const route = useRoute();
reAuthorize(store)
  .then((res) => store.dispatch("OrderStore/getDone"))
  .then((res) => {
    order.value = store?.state?.OrderStore?.done.find(
      (order) =>
        order.orderId == route.params.id &&
        order.orderPosition == route.params.position &&
        order.directionType == route.params.direction
    );
  });
</script>
